import { useCallback, useState } from 'react';
import createUseContext from 'constate';

const useProductDetails = () => {
  const [productDetails, setProductDetails] = useState({});

  const addProductDetails = useCallback((key, data) => setProductDetails((oldProductDetails) => ({
    ...oldProductDetails,
    [key]: data,
  })), []);

  return {
    productDetails,
    addProductDetails,
  };
};

const [ProductDetailsProvider, useProductDetailsContext] = createUseContext(useProductDetails);

export {
  ProductDetailsProvider,
  useProductDetailsContext,
};
